export const typeRole={
  admin:'SUPER_ADMIN',
  moderator:'MODERATOR',
}